// Local dev environment for My Austin theme
// Usage: npm run start:austin  |  ng serve --configuration=austin
export const environment = {
  production: false,
  theme: 'austin' as 'legacy' | 'society' | 'austin',
  appName: 'My Austin',
  domainUrl: 'https://austin-dev.portalwiz.in',
  baseUrl: 'https://society-dev.portalwiz.in/api/public/api',
  storageUrl: 'https://society-dev.portalwiz.in/api/storage/app',
  enquiryFormUrl: 'https://society-dev.portalwiz.in/php',
};
